import { onCleanup } from 'solid-js';

export function useVisibilityPoll(fn: () => void, intervalMs: number): void {
    const handle = window.setInterval(() => {
        if (document.visibilityState === 'visible') fn();
    }, intervalMs);
    onCleanup(() => clearInterval(handle));
}
